import React from "react"

import { type LeadAttachment } from "../../types/lead.types.ts"
import { type LeadPatchSender } from "../lead-workspace-patch.ts"
import { LeadAttachmentsCard } from "./LeadAttachmentsCard.tsx"

interface LeadFilesTabProps {
  attachments?: LeadAttachment[] | null
  canEdit?: boolean
  saving?: boolean
  onPatch: LeadPatchSender
}

/**
 * Split out of Additional Info (2026-08-30): documents/images/files get
 * their own tab instead of sharing a card grid with qualification and the
 * checklist. `LeadAttachmentsCard` itself is unchanged — only its tab moved.
 */
function LeadFilesTab({
  attachments,
  canEdit,
  saving,
  onPatch
}: LeadFilesTabProps) {
  return (
    <div data-testid={"lead-files"}>
      <LeadAttachmentsCard
        attachments={attachments}
        canEdit={canEdit}
        saving={saving}
        onPatch={onPatch}
      />
    </div>
  )
}

export { LeadFilesTab }
